import { render } from "./Comentarios_cat.vue?vue&type=template&id=5a620c43&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"personal\":\"data\",\"asignarValor\":\"options\",\"asignarSector\":\"options\",\"obtenerPersonal\":\"options\",\"refrescarPersonal\":\"options\"}"
import script from "./Comentarios_cat.vue?vue&type=script&lang=js"
export * from "./Comentarios_cat.vue?vue&type=script&lang=js"
script.render = render

export default script